<template>
  <div class="list-table">
    <v-container fluid grid-list-xl>
      <v-layout row wrap>
        <v-flex lg12>
          <v-card>
            <v-toolbar card color="white">
              <v-text-field
                clearable
                flat
                hide-details
                placeholder="Busqueda..."
                solo
                v-model="search"
              ></v-text-field>
              <v-btn icon>
                <v-icon @click="onSearch">search</v-icon>
              </v-btn>
              <v-btn @click="onDownload" icon color="success">
                <v-icon>cloud_download</v-icon>
              </v-btn>
            </v-toolbar>

            <v-divider></v-divider>
            <v-toolbar card color="white"></v-toolbar>
            <v-divider></v-divider>
            <v-divider></v-divider>
            <v-card-text class="pa-0">
              <v-data-table
                :headers="complex.headers"
                :items="invoices"
                :loading="pagination.loading"
                :total-items="pagination.totalItems"
                hide-actions
                no-data-text="Datos no disponibles"
                no-results-text="No se encontraron registros coincidentes"
              >
                <template slot="items" slot-scope="props">
                  <td class="text-sm-left">{{ props.item.invoiceNumber }}</td>
                  <td class="text-sm-left">
                    {{ props.item.lab_invoices.name }}
                  </td>
                  <td class="text-sm-left">{{ props.item.admissionDate }}</td>
                  <td class="text-sm-left">
                    {{ props.item.fdcontrolNumber }}
                  </td>
                  <td class="text-sm-left">{{ props.item.departureDate }}</td>

                  <td class="text-sm-center">
                    <v-chip
                      :color="getColorByTransitStatusClient(props.item)"
                      label
                      small
                      text-color="white"
                    >
                      {{ getLabelByTransitStatus(props.item) }}
                    </v-chip>
                  </td>
                  <td class="text-sm-center">
                    <v-btn @click="handleDetails(props.item)" color="info"
                      >detalles</v-btn
                    >
                  </td>
                  <td class="text-sm-center">
                    <v-btn
                      v-if="props.item.photoDenied"
                      @click="handleComment(props.item, 'rejected')"
                      color="error"
                      small
                      text
                      >Rechazo</v-btn
                    >
                    <v-btn
                      v-if="props.item.photoPayed"
                      @click="handleComment(props.item, 'payment')"
                      color="success"
                      small
                      text
                      >Pago</v-btn
                    >
                    <v-btn
                      v-if="props.item.photoDelivered"
                      @click="handleComment(props.item, 'delivered')"
                      color="info"
                      small
                      text
                      >Entrega</v-btn
                    >
                  </td>
                  <td class="text-sm-center">
                    <v-badge
                      :color="props.item.liquidated == 'NO' ? 'grey' : 'green'"
                      overlap
                    >
                      <span slot="badge">&nbsp;</span>
                    </v-badge>
                  </td>
                  <td class="text-sm-center">
                    <v-btn
                      v-if="props.item.hasFiles"
                      @click="triggerFilesDownload(props.item.id)"
                      icon
                      outlined
                    >
                      <v-icon>archive</v-icon>
                    </v-btn>
                  </td>
                </template>
              </v-data-table>
            </v-card-text>
          </v-card>
          <div class="text-xs-center pt-2" v-if="pagination.pages">
            <v-pagination
              :length="pagination.pages"
              @input="asyncPagination"
              :total-visible="7"
              v-model="pagination.page"
            ></v-pagination>
          </div>
        </v-flex>
      </v-layout>
    </v-container>

    <v-dialog
      max-width="500"
      v-if="information.data"
      v-model="information.show"
    >
      <information
        :key="information.key"
        :item="information.data"
        v-on:close-information="information.show = false"
      ></information>
    </v-dialog>

    <v-dialog max-width="1024" v-if="detail.data" v-model="detail.show">
      <compose
        :key="detail.key"
        :item="detail.data"
        v-on:close-detail="detail.show = false"
      ></compose>
    </v-dialog>

    <v-dialog max-width="350" persistent v-model="loading">
      <loading></loading>
    </v-dialog>
    <v-dialog max-width="500" v-if="msgDialog.message" v-model="msgDialog.show">
      <message
        :options="msgDialog"
        v-on:close="msgDialog.show = false"
      ></message>
    </v-dialog>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import information from './../dialog/DialogInformation'
import compose from './../dialog/DialogDetails'
import loading from './../dialog/DialogLoading'
import message from './../dialog/Message'
import {
  getColorByTransitStatusClient,
  getLabelByTransitStatus,
} from '@/helpers/TransitHelper'
import SessionHelper from '@/helpers/SessionHelper'

export default {
  components: {
    compose,
    loading,
    information,
    message,
  },
  data() {
    return {
      search: '',
      loading: true,
      pagination: {
        page: 1,
        rpp: this.$config.resultsPerPage,
        totalItems: 0,
        loading: true,
        pages: 0,
        search: {},
      },
      information: {
        show: null,
        data: null,
        key: 0,
      },
      detail: {
        show: null,
        data: null,
        key: 0,
      },
      dialog: {
        show: null,
      },
      msgDialog: {
        show: false,
      },
      complex: {
        headers: [
          {
            text: 'Facturas',
            sortable: false,
            value: 'invoiceNumber',
            align: 'left',
          },
          {
            text: 'Laboratorio',
            sortable: false,
            value: 'lab_invoices.name',
            align: 'left',
          },
          {
            text: 'Ingreso',
            sortable: false,
            value: 'admissionDate',
            align: 'left',
          },
          {
            text: 'Control F&D',
            sortable: false,
            value: 'fdcontrolNumber',
            align: 'left',
          },
          {
            text: 'Salida',
            sortable: false,
            value: 'departureDate',
            align: 'left',
          },

          {
            text: 'Estado',
            sortable: false,
            align: 'center',
          },
          {
            text: 'Detalles',
            sortable: false,
            align: 'center',
          },
          {
            text: 'Adjunto',
            sortable: false,
            align: 'center',
          },
          {
            text: 'Pagos',
            sortable: false,
            align: 'center',
          },
          {
            text: 'Archivos',
            sortable: false,
            align: 'center',
          },
        ],
      },
    }
  },
  created() {
    this.asyncPagination()
  },
  computed: {
    ...mapState({
      invoices: state => state.invoices.all,
    }),
  },
  methods: {
    handleDetails(row) {
      this.loading = true
      this.$store
        .dispatch('invoices/getItems', { invoiceId: row.id })
        .then(items => {
          this.loading = false
          this.detail = {
            data: { ...row, products: items ? items : null },
            show: true,
            key: this.key + 1,
          }
        })
    },
    getColorByTransitStatusClient,
    getLabelByTransitStatus,
    helperPaginate(response) {
      this.pagination.totalItems = response.total
      this.pagination.pages =
        Math.ceil(this.pagination.totalItems / this.pagination.rpp) || 0
      this.loading = false
      this.pagination.loading = false
    },
    asyncPagination() {
      this.pagination.loading = true

      let filter = {
        rpp: this.pagination.rpp,
        page: this.pagination.page,
        order: 'DESC',
        orderBy: 'admissionDate',
        ...this.pagination.search,
      }

      return new Promise(resolve => {
        this.$store.dispatch('invoices/getAll', filter).then(response => {
          this.helperPaginate(response)
          return resolve()
        })
      })
    },
    handleComment(row, type) {
      this.information = {
        data: { type: type, ...row },
        show: true,
        key: this.information.key + 1,
      }
    },
    onSearch() {
      const params = { term: this.search }

      Object.keys(params).forEach(function(key) {
        if (params[key] == null || params[key] == '') delete params[key]
      })

      this.pagination.search = params
      this.pagination.page = 1
      this.asyncPagination()
    },
    onDownload() {
      const filter = {
        ...this.pagination.search,
        token: SessionHelper.token,
      }
      this.$socket.emit('exportTransitInvoices', filter)
    },
    triggerFilesDownload(id) {
      const params = {
        invoiceId: id,
        token: SessionHelper.token,
      }
      this.$socket.emit('downloadInvoiceAttachments', params)
    },
  },
  sockets: {
    downloadInvoiceAttachmentsError(message) {
      this.msgDialog = {
        message: message,
        color: 'error',
        show: true,
      }
    },
  },
}
</script>
